import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography } from '../../../../styles/typography';

const leftPadding = 16;
const selectedOptionPadding = 15;

export const wrapper = css({
  position: 'relative',
  width: '100%',
});

export const fieldContainerCss = {
  background: colorsPalette.white,
  padding: `6px ${leftPadding}px `,
  border: `1px solid ${colorsPalette.grey20}`,
  borderRadius: '4px',
  height: '56px',

  '&[data-focus="true"]': {
    border: `1px solid ${colorsPalette.teal}`,
  },

  '&[data-error="true"]': {
    border: `1px solid ${colorsPalette.red120}`,
  },

  '&[data-disabled="true"]': {
    border: `1px solid ${colorsPalette.grey20}`,
    background: colorsPalette.grey10,
  },
  'input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button': {
    WebkitAppearance: 'none',
  },
};

export const iconAlignmentCss = css({
  display: 'flex',
  alignItems: 'center',
});

export const labelCss = css(typography.effra16, {
  position: 'absolute',

  top: '0px',
  left: leftPadding,
  transform: 'translateY(50%)',
  transition: 'transform 0.4s',
  transformOrigin: 'top left',
  fontSize: 16,

  lineHeight: '24px',
  top: '50%',
  height: '24px',
  transform: 'translateY(-50%)',

  div: {
    span: { color: colorsPalette.red },
  },
  color: colorsPalette.tint,
  '&[data-shrink="true"]': {
    transform: 'translateY(-85%) scale(0.75)',
    '&[data-focus="true"]': {
      color: colorsPalette.teal,
      // display: 'none',
    },
    '&[data-error="true"]': {
      color: colorsPalette.red120,
    },
  },

  '&[data-focus="true"]': {
    color: colorsPalette.tintgrey,
    // display: 'none',
  },

  'html[lang="ru"] &[for="HowManyPeople"]': {
    '@media screen and (max-width: 410px)': {
      lineHeight: 1,
    },
  },
});

export const inputCustIconCss = css({});
export const inputButtonCss = css({
  cursor: 'pointer',
  border: 'none',
  background: 'none',
  position: 'relative',
  width: 30,
  height: 20,
});

export const inputIconCss = css({
  // top: -7,
  // position: 'absolute',
  right: 0,
  color: colorsPalette.black,
  '&:before': {
    fontSize: 20,
  },
});

export const fieldCss = css(typography.effra16, {
  border: 'none',
  background: colorsPalette.transparent,
  outline: 'none',
  padding: 0,
  marginTop: 17,
  color: colorsPalette.black,
  width: 'calc(100% - 40px)',
});

export const errorCss = css(typography.effra14, {
  color: colorsPalette.red120,

  '&[data-disabled="true"]': {
    color: colorsPalette.black,
  },
});

export const selectIconCss = css({
  // fontSize: 10,
  color: colorsPalette.grey,
  position: 'absolute',
  right: 16,
  marginLeft: '9px !important',
  font: 'normal normal normal 0.6rem/1 "regus-icon-font"',
  [MediaQueries.md]: {
    font: 'normal normal normal 0.7rem/1 "regus-icon-font"',
    // marginRight: '4px',
    fontSize: '10px',
  },
  [MediaQueries.sm]: {
    font: 'normal normal normal 0.7rem/1 "regus-icon-font"',
    // marginRight: '4px',
    fontSize: '10px',
  },
});

export const selectInputCss = css({
  display: 'block',
  position: 'absolute',
  cursor: 'pointer',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  height: '100%',
  width: '100%',
  outline: 'none',
  background: colorsPalette.transparent,
  border: 'none',
  WebkitAppearance: 'none',
  MozAppearance: 'none',

  '&:focus': {
    outline: 'none',
  },
});

export const errorContainerCss = css({
  position: 'relative',
});
